import { fromJS } from 'immutable';

import { ApiTemplate, UserToken } from '../../../helper/HelperAuth'
import doFetch from '../../../infra/helper/fetchHelper'

export default (flowId) => async (dispatch, getState) => {
    
    const Authorization = UserToken;
    
    const url = ApiTemplate + 'flow/detail?flow_id='+flowId;
    // const url = 'http://localhost:9988/apitemplate/flow/detail?flow_id='+flowId;

    const argument = {  
        method: 'GET',
        headers : {
            'Content-Type':'application/json',
            'Authorization': Authorization,
        }
    }; 

    const response = await doFetch(url,argument);
    var data = fromJS({});
    if(response.ok){
        data = fromJS({});

        try{
            var resJson = await response.json()
            if(resJson !== '' || resJson !== null){
                data = fromJS(resJson);
                data = data.get('data');
            }else{
                data = fromJS({});
            }    
        }catch(ex){
            data = fromJS({});
        }
    }

    return data;
};